import React from "react";
import PowerbiContent from "../function-components/learningCourses/PowerbiContent";

function Powerbi() {
  return (
    <>
      <PowerbiContent />
    </>
  );
}

export default Powerbi;
